import React from 'react';
import { useTranslation } from 'react-i18next';

import { TabButton } from '@/js/libs/ui';

import { languageTitle } from 'src/constants.tsx';
import { LanguageKey } from 'src/types.ts';

interface LanguageTabsProps {
  value: LanguageKey;
  onChange: (newValue: LanguageKey) => void;
}

export const useLanguageState = (): [LanguageKey, React.Dispatch<React.SetStateAction<LanguageKey>>] => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = React.useState<LanguageKey>((i18n.language as LanguageKey) || LanguageKey.German);
  return [language, setLanguage];
};

export const LanguageTabs: React.FC<LanguageTabsProps> = ({ value, onChange }) => {
  const { t } = useTranslation(['backend', 'common', 'language']);
  return (
    <TabButton.Group>
      {(Object.keys(languageTitle) as LanguageKey[]).map((languageKey) => (
        <TabButton
          title={t(`language:${languageTitle[languageKey]}`)}
          active={languageKey === value}
          onClick={() => onChange(languageKey)}
          key={languageKey}
        />
      ))}
    </TabButton.Group>
  );
};
